"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DatabaseRowDataFunctions_1 = require("../../database/functions/DatabaseRowDataFunctions");
var MaxCountsFunctions_1 = require("../../maxCounts/functions/MaxCountsFunctions");
var DatabasesQueryGql_1 = require("../../queries/DatabasesQueryGql");
var PaginatedQueryWrapper_1 = require("../../wrappers/PaginatedQueryWrapper");
var DatabasesDisplayGrid_1 = require("../sharedDisplayGrid/DatabasesDisplayGrid");
function mapResultNodeWithTagFilter(database, resultData) {
    var tag = resultData && resultData.tags && resultData.tags[0];
    return __assign(__assign({}, database), { contentType: 'database', maxDownstreamDatasources: tag && MaxCountsFunctions_1.getMaxDownstreamDatasources(tag), maxDownstreamWorkbooks: tag && MaxCountsFunctions_1.getMaxDownstreamWorkbooks(tag) });
}
exports.mapResultNodeWithTagFilter = mapResultNodeWithTagFilter;
function selectConnectionListResult(resultData) {
    return resultData && resultData.databasesConnection;
}
exports.selectConnectionListResult = selectConnectionListResult;
function selectConnectionListResultWithTagFilter(resultData) {
    return resultData && resultData.tags && resultData.tags[0].databasesConnection;
}
exports.selectConnectionListResultWithTagFilter = selectConnectionListResultWithTagFilter;
// This component is used only from the example. In the actual app, we render the Databases Explorer via
// VizPortal's "Explorer" instead, using these result mappers and the columns from the DatabasesDisplayGrid.
function DatabasesExplorerQueryGrid(props) {
    return (React.createElement(PaginatedQueryWrapper_1.PaginatedQueryWrapper, { queryGql: DatabasesQueryGql_1.DatabasesQueryGql, partialQueryVariables: { orderBy: props.orderBy }, selectConnectionListResult: selectConnectionListResult, mapResultNode: DatabaseRowDataFunctions_1.getRowDataWithMaxCountsForDatabase }, function (_a) {
        var rowStore = _a.rowStore;
        return (React.createElement(DatabasesDisplayGrid_1.DatabasesDisplayGrid, { rowStore: rowStore, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    }));
}
exports.DatabasesExplorerQueryGrid = DatabasesExplorerQueryGrid;
//# sourceMappingURL=DatabasesExplorerQueryGrid.js.map